import React, {useContext} from "react";
import Button from "@mui/material/Button";
import {CustomAccordion} from "../common/index";
import {ContentContext} from "../../ContentContext";

function FAQ() {
    const data = useContext(ContentContext);

    if (!data?.showSections.includes("faq")) {
        return null;
    }

    const footerContent = (
        <>
            <div className={"faq-footer-text"} dangerouslySetInnerHTML={{__html: data?.faqFooterText}} />
            <Button
                className={"button hover-move"}
                href={data?.faqCtaUrl || null}
                target={"_no_blank"}
                rel="noreferrer"
                onClick={() => window.umami?.track("FAQ Click", { label: data?.faqCtaText })}
            >
                {data?.faqCtaText}
            </Button>
        </>
    );

    return (
        <section className={"faq"}>
            <h2>{data?.faqTitle}</h2>
            <CustomAccordion items={data?.faq} footer={footerContent} />
        </section>
    );
}

export default FAQ;
